import { Action, Dispatch } from "redux"
import { mapListToCamelCase, mapToCamelCase } from "../utility"
import { handleAuthorizedRequest, summaries } from "../apis"
import { lang } from "../constants/languages"

export const ANALYSIS_ACTION = {
  FETCH_TOTALS: "@ANALYSIS/FETCH_TOTALS",
  FETCH_TOP_SONG_DATES: "@ANALYSIS/FETCH_TOP_SONG_DATES",
  SELECT_DATE: "@ANALYSIS/SELECT_DATE",
  FETCH_SUMMARY: "@ANALYSIS/FETCH_SUMMARY",
  FETCH_ALL_SUMMARY: "@ANALYSIS/FETCH_ALL_SUMMARY",
  SELECT_FILTER: "@ANALYSIS/SELECT_FILTER",
  FETCH_TOP_SONGS: "@ANALYSIS/FETCH_TOP_SONGS",
  FETCH_FILTER_OPTIONS: "@ANALYSIS/FETCH_FILTER_OPTIONS"
}

export const fetchTotals = () => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await summaries("/summary_totals/", "get")

      dispatch({
        type: ANALYSIS_ACTION.FETCH_TOTALS,
        payload: mapListToCamelCase(response.data)
      })
    },
    lang.analytics.error_on_fetch_totals,
    dispatch
  )
}

export const fetchTopSongDateOptions = () => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await summaries("/top_song_dates/", "get")

      dispatch({
        type: ANALYSIS_ACTION.FETCH_TOP_SONG_DATES,
        payload: response.data
      })
    },
    lang.analytics.error_on_fetch_totals,
    dispatch
  )
}

export const fetchFilterOptions = () => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await summaries("/filter_options/", "get")
      dispatch({
        type: ANALYSIS_ACTION.FETCH_FILTER_OPTIONS,
        payload: mapToCamelCase(response.data)
      })
    },
    lang.analytics.error_on_fetching_filter_options,
    dispatch
  )
}

export const fetchAllSummaries =
  (dateKey: string, type: string, value: string | number, affiliate: boolean, startDate?: string, endDate?: string) =>
  async (dispatch: Dispatch<Action>) => {
    // The difference from fetchSummaries is that we don't pass a date as a query here.
    // The returned value will be an array of objects containing dates and other data.
    await handleAuthorizedRequest(
      async () => {
        const affiliateParam = affiliate ? "&affiliate=1" : ""
        const dateParam = startDate && endDate ? `&start_date=${startDate}&end_date=${endDate}` : ""
        const reqUrl = `/analytics_table/?date_key=${dateKey}&type=${type}&value=${value}${affiliateParam}${dateParam}`

        const response = await summaries(reqUrl, "get")

        dispatch({
          type: ANALYSIS_ACTION.FETCH_ALL_SUMMARY,
          payload: mapListToCamelCase(response.data)
        })
      },
      lang.analytics.error_on_fetching_all_summaries,
      dispatch
    )
  }

export const selectDate = (date: string) => async (dispatch: Dispatch<Action>) => {
  dispatch({
    type: ANALYSIS_ACTION.SELECT_DATE,
    payload: date
  })
}

export const selectFilter = (filter: string) => async (dispatch: Dispatch<Action>) => {
  dispatch({
    type: ANALYSIS_ACTION.SELECT_FILTER,
    payload: filter
  })
}

export const fetchTopSongs = (date: string) => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await summaries(`/user_top_songs/?date=${date}`, "get")

      dispatch({
        type: ANALYSIS_ACTION.FETCH_TOP_SONGS,
        payload: mapListToCamelCase(response.data)
      })
    },
    lang.overview.analysis_top_songs.error_on_fetching_top_songs,
    dispatch
  )
}
